/**
 * @generated SignedSource<<3618f02eba91e0a7911ff29e2076e99f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutinesListItemScheduleMonthly_schedule$data = {
  readonly endDay: number | null;
  readonly startDay: number;
  readonly " $fragmentType": "WorkspaceRoutinesListItemScheduleMonthly_schedule";
};
export type WorkspaceRoutinesListItemScheduleMonthly_schedule$key = {
  readonly " $data"?: WorkspaceRoutinesListItemScheduleMonthly_schedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemScheduleMonthly_schedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutinesListItemScheduleMonthly_schedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDay",
      "storageKey": null
    }
  ],
  "type": "RoutineScheduleMonthly",
  "abstractKey": null
};

(node as any).hash = "2b4a629f69fcb5c1045b90b57f640297";

export default node;
